<template>
  <div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import auth from '../../auth/auth'
  import B64 from '../../auth/base64'
  export default{
    mounted: function () {
      this.$router.push('/monitor');
    },
  }
</script>



// WEBPACK FOOTER //
// refresh.vue?1522f57e